
import { HeroImage } from "./HeroImage";
import { HeroContent } from "./HeroContent";

export const Hero = () => {
  return (
    <section className="relative hero-section">
      <HeroImage />
      <div className="relative z-[5]">
        <HeroContent />
      </div>
    </section>
  );
};
